import {isEmptyValue, valuesMatch} from '@netx/core-components/Form/utils';
import {AttributeAction, AttributeValue} from '../types';
import {ATTRIBUTE_ACTION} from '../constants';

/**
 * Does the applied action change the attributes value
 */
export const actionChangesValue = (
	currentValue: AttributeValue,
	originalValue: AttributeValue,
	action: AttributeAction,
) => {
	return (
		action === ATTRIBUTE_ACTION.CLEAR ||
		([ATTRIBUTE_ACTION.APPEND, ATTRIBUTE_ACTION.REMOVE].includes(
			action as any,
		) &&
			!isEmptyValue(currentValue) &&
			!valuesMatch(currentValue, originalValue))
	);
};

export default actionChangesValue;
